import { AxiosError, AxiosResponse } from "axios";

export function getErrorMsg(error: AxiosError<any>): string {
	if (error.response) {
		if (error.response.data) {
			if (error.response.data.message) {
				return error.response.data.message;
			}

			if (error.response.data.data) {
				return error.response.data.data;
			}
		}
	}

	if (error.message) {
		return error.message;
	}

	return "An unknown error occurred.";
}

export function get200ErrorMsg(response: AxiosResponse<any>): string {
	if (!response.data) {
		return "Something went wrong.";
	}

	if (!response.data.data && !response.data.message) {
		return "Something went wrong.";
	}

	if (response.data.message) {
		return response.data.message;
	}

	return response.data.data;
}
